import { Swiper, EffectFade, Navigation, Pagination, Autoplay } from 'swiper'
import utils from '../utils'
import appUtils from '../app_utils'

// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

Swiper.use([EffectFade])

const dataAttrSuffix = 'section-product'
const dataAttr = 'data-' + dataAttrSuffix
const productExpandedCssClass = 'expanded'

let transitionTl
const productGoto = function productGoto(e) {

  if (transitionTl) {
    return false
  }
  
  if (collapseOnInit) {
    if ($('[' + dataAttr + ']').is('.' + collapsedCssClass)) {
      $('[' + dataAttr + ']').removeClass(collapsedCssClass)
      ScrollTrigger.refresh() // pass true to wait one requestAnimationFrame
    }
  }

  const selector = $(this).attr('data-product-goto')
  const $item = $(selector)
  if($item.length){
    const $transition = $('#mask-transition')
    const $text = $item.find('.section-product__text')
    const $image = $item.find('.section-product__image')
    const $header = $item.find('.header')

    const isPortrait = appUtils.isPortrait()
    transitionTl = gsap.timeline({
      defaults: { duration: 0.4 },
      onComplete: () => transitionTl = null,
    })
    .call(()=>{
      $transition.show()
    })
    .to(appUtils.$bodyOverlay, {
      opacity: 1
    })
    .call(()=>{
      appUtils.setNavigationPanel('')
      appUtils.scrollTo($item, 0, 0)
      gsap.set($image, {y: 200, opacity: 0})
      if(isPortrait) {
        gsap.set($text, {y: '100%'})
      } else {
        gsap.set($text, {x: '100%'})
      }
    })
    .fromTo($('#mask-top'), {attr: {transform: 'scale(1, 1)'}}, {
      attr: {transform: 'scale(1,0.001)'}, // https://greensock.com/forums/topic/24623-apply-transform-as-is/
    })
    .fromTo($('#mask-bottom'), {attr: {transform: 'scale(1, 1)'}}, {
      attr: {transform: 'scale(1,0.001)'}, // https://greensock.com/forums/topic/24623-apply-transform-as-is/
    }, '<')
    .call(()=>{
      $transition.hide()
      gsap.set(appUtils.$bodyOverlay, {opacity: 0})
    })
    .to($image, {y: 0, opacity: 1})
    .to($text, {x: 0, y: 0, ease: 'power'}, '<')
    .to($header, {y: 0, opacity: 1}, '<')

    $item.removeClass(productExpandedCssClass)
  }
}

const productExpand = function(e) {
  const $item = $(this).parents('[data-section-product-item]')
  if($item.length){
    const $text = $item.find('.section-product__text')
    const $image = $item.find('.section-product__image')
    const $header = $item.find('.header')

    const isPortrait = appUtils.isPortrait()

    if ($item.is('.expanded')) {
      transitionTl = gsap.timeline({
        defaults: { duration: 0.4 },
        onComplete: () => {
          transitionTl = null
        }
      })
      .to($image, {x: 0, y: 0, opacity: 1})
      .to($text, {x: 0, y: 0, ease: 'power'}, '<')
      .to($header, {y: 0, opacity: 1}, '<')

      $item.data('swiperInstance').autoplay.start()
    } else {

      let textTo, imageTo
      if(isPortrait) {
        imageTo = { y: -200 }
        textTo = { y: '100%' }
      } else {
        imageTo = { y: 200 }
        textTo = { x: '100%' }
      }

      transitionTl = gsap.timeline({
        onComplete: () => {
          transitionTl = null
        }
      })
      .to($image, {...imageTo, opacity: 0, duration: 0.4})
      .to($text, {...textTo, duration: 0.4, ease: 'power'}, '<')
      .to($header, {y: '-100%', opacity: 0, duration: 0.4}, '<')

      $item.data('swiperInstance').autoplay.pause()
    }

    $item.toggleClass(productExpandedCssClass)

  }
}


const collapsedCssClass = 'collapsed'
const collapseOnInit = false
class SectionProduct {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)
    this.tl = null

    if (collapseOnInit) {
      this.$el.addClass(collapsedCssClass)
    }
    

    this.titleTimeline = null
    this.$title = this.$el.find('[data-section-title]')

    this.$content = this.$el.find('[' + dataAttr + '-content]')
    // this.$items = this.$el.find('[' + dataAttr + '-item]')
    this.items = document.querySelectorAll('[' + dataAttr + '-item]')

    this.itemSwiperInstances = []

    this.timelineArray = []

    this.id = dataAttrSuffix + '-' + args.index
    if(this.$el.attr('id')) {
      this.id = this.$el.attr('id')
    } else {
      this.$el.attr('id', this.id)
    }
    this.init()
  }

  init() {
    /*
    gsap.utils.toArray(this.$items).forEach((item, i) => {
      // gsap.set(item, {opacity: 0, x: getFromX(item)}) // set
      // gsap.set(item, {opacity: 0, y: 50}) // set
    })
    */
    
    const isTouch = appUtils.isTouch()
    this.items.forEach((item, i) => {
      this.addSwiper(item, i)
      if (!isTouch) {
        this.addTimeline(item, i)
      }
    })


    $('[data-product-goto]').on('click', productGoto)
    $('[data-product-expand]').on('click', productExpand)

    $(this.items).on('snapto-view--in', function(){
      setTimeout(()=>{
        if($(this).is('.snapto-view')) {
          $(this).data('swiperInstance').autoplay.start()
        }
      }, 2)
    })
    $(this.items).on('snapto-view--out', function(){
      $(this).data('swiperInstance').autoplay.pause()
    })
  }

  addSwiper(item, index) {
    const swiperItem = item.querySelector('[data-section-product-item-swiper]');
    const swiperInstance = new Swiper(swiperItem, {
      modules: [Autoplay],
      preloadImages: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false,
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 2000,
      }
    })
    swiperInstance.autoplay.stop()
    $(item).data('swiperInstance',swiperInstance)

    this.itemSwiperInstances.push(swiperItem)
    return swiperInstance
  }

  addTimeline(item, index) {
    const itemContent = item.querySelector('[data-section-product-item-content]');
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: "bottom bottom",
        end: "bottom top",
        // end: "top top", // top+=50px
        // ease: "power2",
        // toggleActions: 'play none reverse none',
        // toggleActions: "play none none reverse",
        scrub: true,
        // pin: true
      }
    })
    .to(itemContent, {
      y: '40vh',
      opacity: 0.5
    })

    this.timelineArray.push(timeline)
    return timeline
  }

  destroy() {
    /*
    Kills the ScrollTrigger instance, immediately unpinning and restoring any pin-related changes made to the DOM by ScrollTrigger and removing all scroll-related listeners, etc. so that the instance is eligible for garbage collection.
    */

    if (this.timelineArray.length) {
      this.timelineArray.forEach(tl => {
        tl.scrollTrigger.kill()
        tl.kill()
      })
    }

    if (this.tl) {
      this.tl.scrollTrigger.kill()
      this.tl.kill()
    }

    if (this.titleTimeline) {
      this.titleTimeline.scrollTrigger.kill()
      this.titleTimeline.kill()
    }

    if (this.itemSwiperInstances) {
      this.itemSwiperInstances.forEach((instance, i) => {
        instance.destroy()
      })
    }

    $('[data-product-goto]').off('click')
    $('[data-product-expand]').off('click')

    $(this.items).off('snapto-view--in')
    $(this.items).ff('snapto-view--out')
  }
}

export default {dataAttr: dataAttr, sectionClass: SectionProduct}
